import React from 'react';
import { Link, withRouter } from "react-router-dom"

const Columns = ( addUpd,policy ) => {
		let columns = [
			{
				id: 'name',
				name: 'Nombre',
				selector: row => row.name,
				sortable: true,
				wrap: true,
			},
			
			{
				id: 'actions',
				name: 'Acciones',
				width:'20%',
				button: true,
				cell: row => (
					<div className="d-flex justify-content-between">
						{policy.profiles.create &&
						<div className="p-2">
                            <button className="btn btn-warning btn-sm" title='Editar Perfil' onClick={() => addUpd(row)}><i className="fas fa-edit"></i></button>
                        </div>
                    	}
                    	{policy.permissions.create &&
                        <div className="p-2">
	                        <Link to={`/profile/${row.id}`} className="btn btn-info btn-sm" title='Permisos de Perfil'>
	                            <i className="fa fa-cog"></i>
							</Link>
                        </div>
                    	}
					</div>
					
				),
			}
		];
	return columns;
}

export default Columns;